<template>
<div class='vx-col w-full mt-4'>
    <div class="agregar-codigo">
        <IngresarCodigoJuego @getMisJuegos="getMisJuegos" />
    </div>
    <div class="jugar">
        <vs-popup fullscreen :title="tituloModal" :active.sync="modalJuegos" @close="opcion_juego = '';">
            <div class="emparejar" v-if="opcion_juego== 1">
                <Emparejar :juego_seleccionado="juego_seleccionado" />
            </div>
            <div class="columnas" v-if="opcion_juego== 2">
                <Columnas_game :juego_seleccionado="juego_seleccionado" />
            </div>
            <div class="memoria" v-if="opcion_juego== 3">
                <Memoria :juego_seleccionado="juego_seleccionado" />
            </div>
        </vs-popup>
    </div>
    <div class="lista-mis-juegos">
        <vs-table pagination max-items="25" search :data="arrayMisJuegos" class="mt-4">
            <template slot="header">
                <p class="m-3">Cantidad: {{ arrayMisJuegos.length }} </p>
            </template>
            <template slot="thead">
                <vs-th width="20%">Código</vs-th>
                <vs-th width="20%">Tipo</vs-th>
                <vs-th width="40%">Juego</vs-th>
                <vs-th width="20%">Acciones</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="tr.codigo">
                        {{tr.codigo}}
                    </vs-td>
                    <vs-td :data="tr.juego_tipo">
                        {{tr.juego_tipo}}
                    </vs-td>
                    <vs-td :data="tr.juego_nombre">
                        {{tr.juego_nombre}}
                    </vs-td>
                    <vs-td>
                        <vs-button color="orangered" @click="f_jugar(tr)">Jugar</vs-button>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </div>
</div>
</template>

<script>
import Columnas_game from '../columnas/columnas_game.vue';
import Emparejar from '../emparejar/emparejar.vue';
const Memoria = () => import('../memoria/memoria.vue')
import IngresarCodigoJuego from './ingresarCodigoJuego.vue';
export default {
    components: {
        IngresarCodigoJuego,
        Emparejar,
        Columnas_game,
        Memoria,
    },
    data() {
        return {
            arrayMisJuegos: [],
            usuario: [],
            tituloModal: '',
            modalJuegos: false,
            juego_seleccionado: {},
            opcion_juego:0,
        };
    },
    created() {},
    mounted() {
        let me = this;
        me.f_inicio();
    },
    methods: {
        f_inicio() {
            let me = this;
            me.usuario = JSON.parse(localStorage.getItem('usuario'))[0];
            me.getMisJuegos();
        },
        getMisJuegos() {
            let me = this;
            me.$vs.loading()
            me.$http.get(this.$server_url + 'get_mis_juegos/' + me.usuario.idusuario)
                .then(function (response) {
                    // console.log(response.data)
                    me.arrayMisJuegos = response.data;
                    me.$vs.loading.close()
                })
                .catch(function () {
                    // console.log(error)
                    me.$vs.loading.close()
                });
        },
        f_jugar(item) {
            let me = this;
            // console.log(item)
            localStorage.setItem('idJuego',item.id)
            setTimeout((e) => {
                me.opcion_juego = parseInt(item.id_tipo);
                me.juego_seleccionado = item;
                me.tituloModal = item.juego_tipo;
                me.modalJuegos = true;
            },1000)
          
            //console.log('Jugar Juego', me.arrayMisJuegos)
        }
    }
};
</script>

<style scoped>
.container {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    gap: 10px;
}

.cardss {
    width: 300px;
    /* height: 300px; */
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    flex-grow: 1;
    flex-basis: 200;
}
</style>
